import { useEffect, useState } from 'react';

/** How long the page has to stay still before we consider scrolling over. */
const SCROLL_IDLE_DELAY_MS = 150;
/** Movement smaller than this doesn't count. */
const SCROLL_START_THRESHOLD_PX = 8;

/** True while the user is actively scrolling the page */
export const useIsScrolling = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    let idleTimer: ReturnType<typeof setTimeout> | undefined;
    let scrolling = false;
    let settledScrollY = window.scrollY;

    const settle = () => {
      scrolling = false;
      settledScrollY = window.scrollY;
      setIsScrolling(false);
    };

    const handleScroll = () => {
      if (!scrolling) {
        const moved = Math.abs(window.scrollY - settledScrollY);
        if (moved <= SCROLL_START_THRESHOLD_PX) return;

        scrolling = true;
        setIsScrolling(true);
      }

      clearTimeout(idleTimer);
      idleTimer = setTimeout(settle, SCROLL_IDLE_DELAY_MS);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      clearTimeout(idleTimer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return isScrolling;
};
